export const companyInfo = {
  name: "Axora PS Global LLP",
  gstNumber: "08ACOFA1315L1ZB",
  tagline: "Reliable Indian Agri-Commodity Exports, Quality-Verified and Shipment-Ready.",
  location: "Jaipur, Rajasthan, India",
  address: "2nd Floor, Plot No. D/12/A, RPA Road, Shastri Nagar, Jaipur, Rajasthan 302016, India",
  email: "sales@axorapsglobal.com",
  founders: [
    {
      name: "Puneet Aggarwal",
      role: "Co-founder",
      phone: "+91 9602655086",
      whatsapp: "+91 9602655086",
      email: "sales@axorapsglobal.com"
    },
    {
      name: "Sushant Lohia",
      role: "Co-founder",
      phone: "+91 7340211436",
      whatsapp: "+91 7340211436",
      email: "sales@axorapsglobal.com"
    }
  ],
  businessHours: "Monday-Sunday, 10:00 AM-8:00 PM IST",
  model: "Merchant Exporter (Sourcing from verified partner factories & processors in Rajasthan)"
};

export const productsList = [
  {
    id: "rapeseed-mustard-de-oiled-cake",
    name: "Rapeseed/Mustard De-Oiled Cake (DOC)",
    slug: "rapeseed-mustard-de-oiled-cake",
    subtitle: "Protein-rich oilseed meal / rapeseed-mustard meal sourced from verified Rajasthan partner processors for global animal feed and commodity buyers.",
    hsnCodes: [
      { code: "23069012", desc: "Oil-cake and oil-cake meal, expeller variety, of mustard/rapeseed seeds" },
      { code: "23069021", desc: "Oil-cake and oil-cake meal, solvent extracted / defatted variety, of mustard/rapeseed seeds" }
    ],
    origin: "Rajasthan, India (Sourced from verified partner processors including Niwai sourcing region)",
    exportPort: "Mundra, Kandla / Deendayal, Nhava Sheva / JNPT, Pipavav, and Hazira Ports (FOB / CFR / CIF available)",
    primaryMarket: "Global B2B feed mills & commodity importers (Asia, Middle East, Africa, Europe)",
    tags: ["Animal feed raw material", "Rapeseed/Mustard DOC", "Rajasthan origin", "FOB Indian Port", "Global export"],
    status: "active",
    image: "https://customer-assets-jai6qajn.emergentagent.net/job_verified-doc-supply/artifacts/dnzw6tul_logo.webp",
    bannerImage: "https://images.unsplash.com/photo-1593617761943-9099951a0769?crop=entropy&cs=srgb&fm=jpg&q=85",
    grades: [
      "Standard Rapeseed/Mustard DOC",
      "High Protein Rapeseed/Mustard Meal (Subject to availability & COA)",
      "Expeller Rapeseed-Mustard Cake",
      "Solvent Extracted / Defatted Rapeseed/Mustard DOC"
    ],
    packaging: "50 kg PP / HDPE export bags as standard. Custom buyer marking available. Container stuffing & bag stacking photos provided.",
    containerLoad: "Standard 20ft dry container (Typical load: 22-24 MT subject to packing, moisture and port rules)",
    leadTime: "7-15 working days after order confirmation and payment / LC readiness.",
    shelfLife: "6 months under cool, dry, moisture-protected storage.",
    storage: "Store in a dry, covered, well-ventilated warehouse. Protect from moisture, rain, pests, and direct contamination.",
    specifications: [
      { parameter: "Product Name", typical: "Rapeseed/Mustard De-Oiled Cake (DOC)", notes: "Also known as Rapeseed-Mustard Meal" },
      { parameter: "Origin", typical: "Rajasthan, India", notes: "Sourced from verified partner processors" },
      { parameter: "Crude Protein", typical: "36-38% min typical", notes: "Final value confirmed by batch COA" },
      { parameter: "Moisture", typical: "10-12% max typical", notes: "Final value confirmed by batch COA" },
      { parameter: "Residual Oil / Fat", typical: "1.0-2.0% max typical (Solvent-extracted)", notes: "Expeller cake may have higher oil" },
      { parameter: "Sand and Silica", typical: "2% max", notes: "Confirmed by batch COA / test report" },
      { parameter: "Crude Fiber", typical: "12% max typical", notes: "Final value as per COA" },
      { parameter: "Ash", typical: "7-8% max typical", notes: "Final value as per COA" },
      { parameter: "Foreign Matter", typical: "As per buyer specification / COA", notes: "Tested on request" },
      { parameter: "Appearance", typical: "Brown to dark brown oilseed meal texture", notes: "Visual variation possible" },
      { parameter: "Odor", typical: "Characteristic oilseed meal aroma", notes: "Fresh and non-contaminated" },
      { parameter: "Form", typical: "Meal / cake / granular export form", notes: "Depends on grade" },
      { parameter: "Aflatoxin", typical: "Available on request / As per destination", notes: "Subject to lab testing availability" },
      { parameter: "Salmonella / Microbiology", typical: "Available on request / Buyer spec", notes: "If required by importing country" },
      { parameter: "Heavy Metals / Pesticides", typical: "Available on request", notes: "Subject to lab testing availability" },
      { parameter: "GMO Status", typical: "Non-GMO origin / Placeholder", notes: "Verified per batch requirement" }
    ],
    qualityChecks: [
      "Batch-wise COA coordination",
      "Moisture & crude protein check",
      "Residual oil & fat test",
      "Sand and silica check (2% max)",
      "Visual export bag & packaging inspection",
      "Third-party inspection available on request (SGS / Geo-Chem)"
    ],
    documents: [
      "Commercial Invoice",
      "Packing List",
      "Bill of Lading",
      "Certificate of Origin",
      "Certificate of Analysis (COA)",
      "Phytosanitary Certificate (if required)",
      "Fumigation Certificate (if required)",
      "Insurance Certificate where applicable",
      "Third-Party Inspection Report (on request)"
    ]
  },
  {
    id: "soybean-meal-doc",
    name: "Soybean De-Oiled Cake (Soy Meal)",
    slug: "soybean-meal-doc",
    subtitle: "High-protein animal feed ingredient sourced from certified crushing units in central and western India.",
    hsnCodes: [
      { code: "23040010", desc: "Oil-cake and other solid residues of soybean" }
    ],
    origin: "Madhya Pradesh & Rajasthan, India",
    exportPort: "Mundra / JNPT / Pipavav Port, India",
    primaryMarket: "Global B2B feed buyers",
    tags: ["Animal feed", "Soy DOC", "High protein", "FOB Indian Port"],
    status: "coming_soon",
    image: "https://customer-assets-jai6qajn.emergentagent.net/job_verified-doc-supply/artifacts/dnzw6tul_logo.webp",
    bannerImage: "https://images.unsplash.com/photo-1593617761943-9099951a0769?crop=entropy&cs=srgb&fm=jpg&q=85",
    grades: ["Standard 46% Protein Soy Meal", "Hipro Soy DOC"],
    packaging: "50 kg export bags or Jumbo bags",
    containerLoad: "22-24 MT per 20ft container",
    leadTime: "Available on inquiry",
    shelfLife: "6 months",
    storage: "Dry and well ventilated warehouse",
    specifications: [
      { parameter: "Crude Protein", typical: "44-46% min", notes: "Batch COA support" },
      { parameter: "Moisture", typical: "12% max", notes: "Batch COA support" },
      { parameter: "Fiber", typical: "7% max", notes: "Batch COA support" }
    ],
    qualityChecks: ["COA coordination", "Moisture and Protein testing"],
    documents: ["Invoice", "BL", "COA", "Origin"]
  },
  {
    id: "groundnut-extraction",
    name: "Groundnut De-Oiled Cake",
    slug: "groundnut-extraction",
    subtitle: "Nutritious oilseed meal for poultry and aqua feed formulations.",
    hsnCodes: [{ code: "23050010", desc: "Oil-cake and other solid residues of groundnut" }],
    origin: "Gujarat & Rajasthan, India",
    exportPort: "Mundra / Pipavav Port, India",
    primaryMarket: "Global markets",
    tags: ["Groundnut DOC", "Poultry feed", "Export grade"],
    status: "coming_soon",
    image: "https://customer-assets-jai6qajn.emergentagent.net/job_verified-doc-supply/artifacts/dnzw6tul_logo.webp",
    bannerImage: "https://images.unsplash.com/photo-1593617761943-9099951a0769?crop=entropy&cs=srgb&fm=jpg&q=85",
    grades: ["Solvent Extracted Groundnut Meal"],
    packaging: "50 kg PP export bags",
    containerLoad: "20-22 MT per 20ft container",
    leadTime: "Available on inquiry",
    shelfLife: "6 months",
    storage: "Dry warehouse",
    specifications: [
      { parameter: "Crude Protein", typical: "45% min", notes: "COA required" },
      { parameter: "Moisture", typical: "10% max", notes: "COA required" }
    ],
    qualityChecks: ["Batch COA"],
    documents: ["Invoice", "BL", "COA"]
  },
  {
    id: "sesame-seed-meal",
    name: "Sesame Oil Cake",
    slug: "sesame-seed-meal",
    subtitle: "Rich protein and mineral supplement for cattle and specialty animal feeds.",
    hsnCodes: [{ code: "23069090", desc: "Other oil-cakes and meals" }],
    origin: "Rajasthan & Gujarat, India",
    exportPort: "Mundra / Hazira Port, India",
    primaryMarket: "Global buyers",
    tags: ["Sesame cake", "Feed ingredient"],
    status: "coming_soon",
    image: "https://customer-assets-jai6qajn.emergentagent.net/job_verified-doc-supply/artifacts/dnzw6tul_logo.webp",
    bannerImage: "https://images.unsplash.com/photo-1593617761943-9099951a0769?crop=entropy&cs=srgb&fm=jpg&q=85",
    grades: ["Expeller & Extracted"],
    packaging: "50 kg bags",
    containerLoad: "21-23 MT per 20ft container",
    leadTime: "Available on inquiry",
    shelfLife: "6 months",
    storage: "Dry warehouse",
    specifications: [
      { parameter: "Crude Protein", typical: "38-40% min", notes: "COA support" }
    ],
    qualityChecks: ["COA inspection"],
    documents: ["Invoice", "BL", "COA"]
  }
];

export const exportProcessSteps = [
  {
    step: 1,
    title: "Buyer Inquiry & Specification Review",
    description: "Global buyer shares product interest (Rapeseed/Mustard DOC), quantity, destination port, required grade, and target shipment terms (FOB / CFR / CIF)."
  },
  {
    step: 2,
    title: "Specification & Contract Confirmation",
    description: "Axora PS Global LLP confirms indicative specs, packing in 50kg PP/HDPE export bags, container load, pricing, and payment terms (LC / TT)."
  },
  {
    step: 3,
    title: "Sourcing from Verified Partner Network",
    description: "Material is sourced directly from verified partner processors and crushing units in Rajasthan (including Niwai and surrounding quality hubs)."
  },
  {
    step: 4,
    title: "Quality Inspection & COA Coordination",
    description: "Batch-wise laboratory testing is conducted for protein, moisture, sand & silica (2% max), and oil content. Certificate of Analysis is coordinated."
  },
  {
    step: 5,
    title: "Export Documentation Preparation",
    description: "Commercial Invoice, Packing List, Certificate of Origin, COA, Bill of Lading, and phytosanitary/fumigation certificates (if required) are prepared."
  },
  {
    step: 6,
    title: "Container Stuffing & Bag Stacking",
    description: "Clean 20ft dry containers are loaded at partner warehouses with proper bag stacking. Container stuffing photos and seal numbers are shared."
  },
  {
    step: 7,
    title: "Dispatch through Suitable Indian Ports",
    description: "Shipment is arranged through Mundra, Kandla / Deendayal, Nhava Sheva / JNPT, Pipavav, or Hazira Port depending on route and destination."
  },
  {
    step: 8,
    title: "Post-Shipment Document Dispatch",
    description: "Complete set of shipping documents is dispatched via courier or bank channels for smooth customs clearance and import processing."
  }
];

export const marketsServed = [
  {
    country: "Vietnam",
    status: "Key Market",
    description: "Important export destination for our rapeseed/mustard DOC. We regularly coordinate feed-grade shipments to Vietnamese feed mills and commodity importers.",
    buyerTypes: ["Feed Mills", "Animal Feed Manufacturers", "Trading Companies", "Commodity Importers", "Procurement Teams"]
  },
  {
    country: "Bangladesh",
    status: "Buyer Inquiries Welcome",
    description: "Active trade corridor inquiries welcome for land and sea-borne agri-commodity supply.",
    buyerTypes: ["Feed Millers", "Agri Traders"]
  },
  {
    country: "Nepal",
    status: "Buyer Inquiries Welcome",
    description: "Road and transit routes available for quality oilseed meal and feed ingredients.",
    buyerTypes: ["Livestock Feed Producers", "Distributors"]
  },
  {
    country: "Thailand",
    status: "Buyer Inquiries Welcome",
    description: "Growing demand for protein meals; port-to-port CFR / CIF quotations available.",
    buyerTypes: ["Aqua & Poultry Feed Mills"]
  },
  {
    country: "Malaysia",
    status: "Buyer Inquiries Welcome",
    description: "Regular shipping schedule connectivity from Indian ports to Port Klang and Pasir Gudang.",
    buyerTypes: ["Commodity Importers", "Feed Formulators"]
  },
  {
    country: "Indonesia",
    status: "Buyer Inquiries Welcome",
    description: "Bulk feed raw material supply coordination with strict compliance and COA verification.",
    buyerTypes: ["Livestock Feed Conglomerates"]
  },
  {
    country: "Philippines",
    status: "Buyer Inquiries Welcome",
    description: "Containerized 20ft export shipments tailored for regional feed manufacturing plants.",
    buyerTypes: ["Feed Millers", "Trading Importers"]
  },
  {
    country: "Middle East / GCC",
    status: "Buyer Inquiries Welcome",
    description: "Reliable oilseed meal export channels for livestock feed industries across the Middle East.",
    buyerTypes: ["Feed Distributors", "Livestock Producers"]
  },
  {
    country: "Africa",
    status: "Buyer Inquiries Welcome",
    description: "Containerized agri-commodity shipments meeting destination import regulations.",
    buyerTypes: ["Importers & Feed Producers"]
  },
  {
    country: "Europe",
    status: "Subject to Buyer Requirements",
    description: "Export supply available subject to specific European buyer quality standards and regulatory compliance.",
    buyerTypes: ["Global Trading Companies", "Feed Importers"]
  },
  {
    country: "Other Global Markets",
    status: "Available on Inquiry",
    description: "Customized export solutions for buyers across worldwide import destinations.",
    buyerTypes: ["Global Importers & Procurement Teams"]
  }
];

export const complianceList = [
  { title: "LLP Registration & Legal Entity", status: "Verified & Active", desc: "Registered as Axora PS Global LLP in Jaipur, Rajasthan, India." },
  { title: "GST Registration", status: "08ACOFA1315L1ZB", desc: "Goods and Services Tax registration for compliant domestic procurement and zero-rated export processing." },
  { title: "Import Export Code (IEC)", status: "Verified & Active", desc: "Mandatory primary registration for Indian merchant exporters issued by DGFT." },
  { title: "IOPEPC / APEDA RCMC", status: "Verified & Active", desc: "Registration-Cum-Membership Certificate with export promotion councils for oilseeds and allied products." },
  { title: "AD Code & Bank Export Setup", status: "Verified & Active", desc: "Authorized Dealer (AD) code registered with Indian port customs for seamless shipping clearance." },
  { title: "Certificate of Origin Support", status: "Available per Shipment", desc: "Chamber of Commerce or relevant authority certificates provided for preferential tariff claims." },
  { title: "Batch-wise Certificate of Analysis (COA)", status: "Active Standard", desc: "Laboratory test reports covering protein, moisture, silica, and fat content for every export batch." },
  { title: "Third-Party Inspection Support", status: "Available on Request", desc: "Independent survey and inspection by SGS, Geo-Chem, or equivalent agency upon request." },
  { title: "Phytosanitary & Fumigation Docs", status: "As per Destination Rule", desc: "Plant quarantine clearance and ISPM-15 compliant wooden pallet fumigation certificates." },
  { title: "ISO 22000 / HACCP / GMP+", status: "Partner Facility Standard", desc: "Sourced from processing units holding international food safety and feed safety standard certifications." }
];

export const faqsList = [
  {
    q: "Is Axora PS Global LLP a manufacturer?",
    a: "Axora PS Global LLP is a Jaipur-based merchant exporter. We do not manufacture products directly. Instead, we partner with verified crushing and processing units in Rajasthan, coordinate rigorous quality checks, manage export documentation, and oversee container shipments through major Indian ports."
  },
  {
    q: "What is your primary export product?",
    a: "Our primary export product is Rapeseed/Mustard De-Oiled Cake, also known as Rapeseed/Mustard DOC, Rapeseed-Mustard Meal, or Mustard/Rapeseed Oil Cake, widely used as a high-protein animal feed raw material."
  },
  {
    q: "What HSN codes apply to rapeseed/mustard DOC?",
    a: "HSN 23069012 applies to expeller variety oil-cake and HSN 23069021 applies to solvent extracted / defatted variety of mustard/rapeseed seeds meal, subject to final product classification and customs rules."
  },
  {
    q: "What is the typical protein level in your Rapeseed/Mustard DOC?",
    a: "Typical crude protein is around 36-38% minimum, depending on the specific batch and grade (solvent extracted vs expeller cake). Final parameters are confirmed strictly by batch-wise Certificate of Analysis (COA)."
  },
  {
    q: "What is the sand and silica limit?",
    a: "Our standard specification maintains sand and silica at 2% max, verified batch-wise prior to dispatch."
  },
  {
    q: "What container load can be accommodated?",
    a: "Standard 20ft dry containers typically load 22 to 24 Metric Tons (MT), depending on bag packing, moisture conditions, shipping line approval, and destination port regulations."
  },
  {
    q: "Which ports do you ship from?",
    a: "We coordinate shipments through suitable Indian ports including Mundra Port, Kandla / Deendayal Port, Nhava Sheva / JNPT, Pipavav Port, and Hazira Port depending on buyer destination, vessel availability, and commercial route."
  },
  {
    q: "Can international buyers request pre-shipment third-party inspection?",
    a: "Yes, inspection by independent agencies such as SGS or Geo-Chem can be arranged upon request and commercial agreement."
  },
  {
    q: "Do you export globally beyond Vietnam?",
    a: "Yes. While Vietnam is a key market, we serve global B2B buyers across Asia, the Middle East, Africa, Europe, and other feasible import destinations."
  },
  {
    q: "What payment terms do you accept for export contracts?",
    a: "We accept Irrevocable Letter of Credit (LC) at sight and Telegraphic Transfer (TT / Wire Transfer) as per mutually agreed export contract terms."
  }
];
